export const parseJwtClaims = (token: string): Record<string, string> => {
  try {
    const parts = token.split('.');
    if (parts.length < 2) return {};
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(payload)
        .split('')
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join('')
    );
    const parsed = JSON.parse(json) as Record<string, unknown>;
    return Object.fromEntries(
      Object.entries(parsed).map(([key, value]) => [key, String(value ?? '')])
    );
  } catch {
    return {};
  }
};

export const findStoreToken = (): string | null => {
  const legacy = localStorage.getItem('store_token');
  if (legacy) return legacy;

  for (let i = 0; i < localStorage.length; i += 1) {
    const key = localStorage.key(i);
    if (key?.startsWith('store_token__')) {
      const value = localStorage.getItem(key);
      if (value) return value;
    }
  }
  return null;
};

export const readTenantFromToken = (): { tenantId: number; tenantCode: string } | null => {
  const token = findStoreToken();
  if (!token) return null;

  const claims = parseJwtClaims(token);
  const tenantCode = claims.tenant_code;
  const tenantIdRaw = claims.tenant_id;
  if (!tenantCode || !tenantIdRaw) return null;

  const tenantId = Number.parseInt(tenantIdRaw, 10);
  if (!Number.isFinite(tenantId)) return null;

  return { tenantId, tenantCode };
};
